export var UserSubscriptionTypeCategoriesEnum;
(function (UserSubscriptionTypeCategoriesEnum) {
    UserSubscriptionTypeCategoriesEnum[UserSubscriptionTypeCategoriesEnum["Course"] = 1] = "Course";
    UserSubscriptionTypeCategoriesEnum[UserSubscriptionTypeCategoriesEnum["LocationPackage"] = 2] = "LocationPackage";
    UserSubscriptionTypeCategoriesEnum[UserSubscriptionTypeCategoriesEnum["LocationPerSeat"] = 3] = "LocationPerSeat";
})(UserSubscriptionTypeCategoriesEnum || (UserSubscriptionTypeCategoriesEnum = {}));
export var Integrations;
(function (Integrations) {
    Integrations[Integrations["StripeIntegrationId"] = 1] = "StripeIntegrationId";
    Integrations[Integrations["AcutrackIntegrationId"] = 2] = "AcutrackIntegrationId";
    Integrations[Integrations["DigitalAssetIntegrationId"] = 3] = "DigitalAssetIntegrationId";
})(Integrations || (Integrations = {}));
//# sourceMappingURL=package.model.js.map